/* eslint-disable antfu/consistent-list-newline */
import type { Component } from "vue";
import AccessibilitySvg from "lucide-static/icons/accessibility.svg?raw";
import AppWindowSvg from "lucide-static/icons/app-window.svg?raw";
import ArchiveSvg from "lucide-static/icons/archive.svg?raw";
import AtSignSvg from "lucide-static/icons/at-sign.svg?raw";
import BellSvg from "lucide-static/icons/bell.svg?raw";
import BookOpenSvg from "lucide-static/icons/book-open.svg?raw";
import BookmarkSvg from "lucide-static/icons/bookmark.svg?raw";
import BotSvg from "lucide-static/icons/bot.svg?raw";
import BoxSvg from "lucide-static/icons/box.svg?raw";
import BrainSvg from "lucide-static/icons/brain.svg?raw";
import BriefcaseMedicalSvg from "lucide-static/icons/briefcase-medical.svg?raw";
import BugSvg from "lucide-static/icons/bug.svg?raw";
import Building2Svg from "lucide-static/icons/building-2.svg?raw";
import CalculatorSvg from "lucide-static/icons/calculator.svg?raw";
import CalendarSvg from "lucide-static/icons/calendar.svg?raw";
import CarSvg from "lucide-static/icons/car.svg?raw";
import ChartAreaSvg from "lucide-static/icons/chart-area.svg?raw";
import ChartPieSvg from "lucide-static/icons/chart-pie.svg?raw";
import CircleDotDashedSvg from "lucide-static/icons/circle-dot-dashed.svg?raw";
import CircleFadingArrowUpSvg from "lucide-static/icons/circle-fading-arrow-up.svg?raw";
import CircleQuestionMark from "lucide-static/icons/circle-question-mark.svg?raw";
import CircleUserSvg from "lucide-static/icons/circle-user.svg?raw";
import ClipboardClockSvg from "lucide-static/icons/clipboard-clock.svg?raw";
import ClipboardSvg from "lucide-static/icons/clipboard.svg?raw";
import CloudSvg from "lucide-static/icons/cloud.svg?raw";
import CodeSvg from "lucide-static/icons/code.svg?raw";
import CreditCardSvg from "lucide-static/icons/credit-card.svg?raw";
import DatabaseSvg from "lucide-static/icons/database.svg?raw";
import EyeSvg from "lucide-static/icons/eye.svg?raw";
import FingerprintSvg from "lucide-static/icons/fingerprint.svg?raw";
import FlagSvg from "lucide-static/icons/flag.svg?raw";
import FlaskConicalSvg from "lucide-static/icons/flask-conical.svg?raw";
import Gamepad2Svg from "lucide-static/icons/gamepad-2.svg?raw";
import GemSvg from "lucide-static/icons/gem.svg?raw";
import GiftSvg from "lucide-static/icons/gift.svg?raw";
import GraduationCapSvg from "lucide-static/icons/graduation-cap.svg?raw";
import HouseSvg from "lucide-static/icons/house.svg?raw";
import InfoSvg from "lucide-static/icons/info.svg?raw";
import KeyRoundSvg from "lucide-static/icons/key-round.svg?raw";
import LandmarkSvg from "lucide-static/icons/landmark.svg?raw";
import Layers2Svg from "lucide-static/icons/layers-2.svg?raw";
import LayoutGridSvg from "lucide-static/icons/layout-grid.svg?raw";
import LayoutListSvg from "lucide-static/icons/layout-list.svg?raw";
import LifeBuoySvg from "lucide-static/icons/life-buoy.svg?raw";
import LightbulbSvg from "lucide-static/icons/lightbulb.svg?raw";
import LinkSvg from "lucide-static/icons/link.svg?raw";
import MapPinnedSvg from "lucide-static/icons/map-pinned.svg?raw";
import MicroscopeSvg from "lucide-static/icons/microscope.svg?raw";
import MonitorSvg from "lucide-static/icons/monitor.svg?raw";
import MoonStarSvg from "lucide-static/icons/moon-star.svg?raw";
import OctagonAlertSvg from "lucide-static/icons/octagon-alert.svg?raw";
import PaletteSvg from "lucide-static/icons/palette.svg?raw";
import PaperclipSvg from "lucide-static/icons/paperclip.svg?raw";
import PencilSvg from "lucide-static/icons/pencil.svg?raw";
import PlaneSvg from "lucide-static/icons/plane.svg?raw";
import PowerSvg from "lucide-static/icons/power.svg?raw";
import PresentationSvg from "lucide-static/icons/presentation.svg?raw";
import PuzzleSvg from "lucide-static/icons/puzzle.svg?raw";
import RocketSvg from "lucide-static/icons/rocket.svg?raw";
import SchoolSvg from "lucide-static/icons/school.svg?raw";
import SendSvg from "lucide-static/icons/send.svg?raw";
import SettingsSvg from "lucide-static/icons/settings.svg?raw";
import ShieldSvg from "lucide-static/icons/shield.svg?raw";
import ShipSvg from "lucide-static/icons/ship.svg?raw";
import ShoppingCartSvg from "lucide-static/icons/shopping-cart.svg?raw";
import SmartphoneSvg from "lucide-static/icons/smartphone.svg?raw";
import SparklesSvg from "lucide-static/icons/sparkles.svg?raw";
import SpeechSvg from "lucide-static/icons/speech.svg?raw";
import SproutSvg from "lucide-static/icons/sprout.svg?raw";
import SquareCheckSvg from "lucide-static/icons/square-check.svg?raw";
import SquarePlusSvg from "lucide-static/icons/square-plus.svg?raw";
import SunSvg from "lucide-static/icons/sun.svg?raw";
import TargetSvg from "lucide-static/icons/target.svg?raw";
import ThumbsUpSvg from "lucide-static/icons/thumbs-up.svg?raw";
import TrophySvg from "lucide-static/icons/trophy.svg?raw";
import UsersRoundSvg from "lucide-static/icons/users-round.svg?raw";
import Volume2Svg from "lucide-static/icons/volume-2.svg?raw";
import WalletSvg from "lucide-static/icons/wallet.svg?raw";
import WandSparklesSvg from "lucide-static/icons/wand-sparkles.svg?raw";
import WrenchSvg from "lucide-static/icons/wrench.svg?raw";
import ZapSvg from "lucide-static/icons/zap.svg?raw";

import {
  Accessibility, AppWindow, Archive, AtSign, Bell, Bookmark, BookOpen, Bot,
  Box, Brain, BriefcaseMedical, Bug, Building2, Calculator, Calendar, Car,
  ChartArea, ChartPie, CircleDotDashed, CircleFadingArrowUp, CircleHelp, CircleUser, Clipboard, ClipboardClock, Cloud, Code,
  CreditCard, Database, Eye, Fingerprint, Flag, FlaskConical, Gamepad2, Gem,
  Gift, GraduationCap, House, Info, KeyRound, Landmark, Layers2, LayoutGrid,
  LayoutList, LifeBuoy, Lightbulb, Link, MapPinned, Microscope, Monitor,
  MoonStar, OctagonAlert, Palette, Paperclip, Pencil, Plane, Power, Presentation, Puzzle,
  Rocket, School, Send, Settings, Shield, Ship, ShoppingCart, Smartphone, Sparkles, Speech, Sprout, SquareCheck, SquarePlus, Sun,
  Target, ThumbsUp, Trophy, UsersRound, Volume2, Wallet, WandSparkles, Wrench, Zap,
} from "lucide-vue-next";

export interface CuratedIcon {
  id: string;
  description: string;
  component: Component;
  rawSvg: string;
  aliases?: string[];
}

export const IconSet: CuratedIcon[] = [
  {
    id: "LayoutGrid",
    description: "layout grid",
    component: LayoutGrid,
    rawSvg: LayoutGridSvg,
    aliases: ["grid", "layout", "dashboard", "grid layout", "grid view", "interface", "ui", "design"],
  },
  {
    id: "House",
    description: "house",
    component: House,
    rawSvg: HouseSvg,
    aliases: ["home", "building", "residence", "real estate", "property", "housing", "location"],
  },
  {
    id: "Box",
    description: "box",
    component: Box,
    rawSvg: BoxSvg,
    aliases: ["package", "container", "storage", "shipping", "delivery", "product", "project"],
  },
  {
    id: "Rocket",
    description: "rocket",
    component: Rocket,
    rawSvg: RocketSvg,
    aliases: ["launch", "spaceship", "ship", "space", "technology", "startup", "project"],
  },
  {
    id: "Trophy",
    description: "trophy",
    component: Trophy,
    rawSvg: TrophySvg,
    aliases: ["award", "prize", "medal", "winner", "achievement", "success", "recognition"],
  },
  {
    id: "UsersRound",
    description: "users round",
    component: UsersRound,
    rawSvg: UsersRoundSvg,
    aliases: ["people", "team", "group", "members", "users", "community", "social"],
  },
  {
    id: "Target",
    description: "target",
    component: Target,
    rawSvg: TargetSvg,
    aliases: ["goal", "aim", "bullseye", "objective", "focus", "precision", "project"],
  },
  {
    id: "Palette",
    description: "palette",
    component: Palette,
    rawSvg: PaletteSvg,
    aliases: ["colors", "paint", "art", "design", "color picker", "creativity"],
  },
  {
    id: "Zap",
    description: "zap",
    component: Zap,
    rawSvg: ZapSvg,
    aliases: ["epic", "lightning", "bolt", "electric", "power", "energy", "electricity"],
  },
  {
    id: "Accessibility",
    description: "accessibility",
    component: Accessibility,
    rawSvg: AccessibilitySvg,
    aliases: ["a11y", "inclusive", "disability", "assist"],
  },
  {
    id: "AppWindow",
    description: "app window",
    component: AppWindow,
    rawSvg: AppWindowSvg,
    aliases: ["application", "program", "software", "window", "app"],
  },
  {
    id: "Archive",
    description: "archive",
    component: Archive,
    rawSvg: ArchiveSvg,
    aliases: ["storage", "backup", "save", "history"],
  },
  {
    id: "AtSign",
    description: "at sign",
    component: AtSign,
    rawSvg: AtSignSvg,
    aliases: ["email", "mail", "contact", "address", "at", "communication"],
  },
  {
    id: "Bell",
    description: "bell",
    component: Bell,
    rawSvg: BellSvg,
    aliases: ["notification", "alert", "ring", "sound", "reminder"],
  },
  {
    id: "Bookmark",
    description: "bookmark",
    component: Bookmark,
    rawSvg: BookmarkSvg,
    aliases: ["save", "favorite", "mark", "tag", "user story"],
  },
  {
    id: "BookOpen",
    description: "book open",
    component: BookOpen,
    rawSvg: BookOpenSvg,
    aliases: ["read", "book", "document", "text", "story"],
  },
  {
    id: "Bot",
    description: "bot",
    component: Bot,
    rawSvg: BotSvg,
    aliases: ["robot", "automation", "ai", "artificial intelligence", "machine"],
  },
  {
    id: "Brain",
    description: "brain",
    component: Brain,
    rawSvg: BrainSvg,
    aliases: ["mind", "intelligence", "think", "idea", "ai", "artificial intelligence"],
  },
  {
    id: "BriefcaseMedical",
    description: "briefcase medical",
    component: BriefcaseMedical,
    rawSvg: BriefcaseMedicalSvg,
    aliases: ["health", "medical", "doctor", "hospital", "project"],
  },
  {
    id: "Bug",
    description: "bug",
    component: Bug,
    rawSvg: BugSvg,
    aliases: ["insect", "error", "debug", "issue", "bugs"],
  },
  {
    id: "Building2",
    description: "building",
    component: Building2,
    rawSvg: Building2Svg,
    aliases: ["office", "structure", "company", "workplace", "project"],
  },
  {
    id: "Calculator",
    description: "calculator",
    component: Calculator,
    rawSvg: CalculatorSvg,
    aliases: ["math", "compute", "calculate", "numbers"],
  },
  {
    id: "Calendar",
    description: "calendar",
    component: Calendar,
    rawSvg: CalendarSvg,
    aliases: ["date", "schedule", "event", "time"],
  },
  {
    id: "Car",
    description: "car",
    component: Car,
    rawSvg: CarSvg,
    aliases: ["vehicle", "automobile", "transport", "drive"],
  },
  {
    id: "ChartArea",
    description: "chart area",
    component: ChartArea,
    rawSvg: ChartAreaSvg,
    aliases: ["graph", "statistics", "data", "trend", "area chart"],
  },
  {
    id: "ChartPie",
    description: "chart pie",
    component: ChartPie,
    rawSvg: ChartPieSvg,
    aliases: ["pie chart", "statistics", "data", "percentage"],
  },
  {
    id: "CircleDotDashed",
    description: "circle dot dashed",
    component: CircleDotDashed,
    rawSvg: CircleDotDashedSvg,
    aliases: ["progress", "in progress", "partial", "ongoing", "task", "development", "draft", "incomplete", "pending", "work in progress", "unfinished"],
  },
  {
    id: "CircleFadingArrowUp",
    description: "circle arrow up",
    component: CircleFadingArrowUp,
    rawSvg: CircleFadingArrowUpSvg,
    aliases: ["upload", "progress", "loading", "arrow", "circle arrow", "improvement", "improvements"],
  },
  {
    id: "CircleHelp",
    description: "circle help",
    component: CircleHelp,
    rawSvg: CircleQuestionMark,
    aliases: ["question", "support", "assist", "guide"],
  },
  {
    id: "CircleUser",
    description: "circle user",
    component: CircleUser,
    rawSvg: CircleUserSvg,
    aliases: ["profile", "account", "person", "avatar"],
  },
  {
    id: "Clipboard",
    description: "clipboard",
    component: Clipboard,
    rawSvg: ClipboardSvg,
    aliases: ["copy", "paste", "notes", "list"],
  },
  {
    id: "ClipboardClock",
    description: "clipboard clock",
    component: ClipboardClock,
    rawSvg: ClipboardClockSvg,
    aliases: ["backlog", "todo", "pending", "tasks", "waiting", "queue", "scheduled", "planned"],
  },
  {
    id: "Cloud",
    description: "cloud",
    component: Cloud,
    rawSvg: CloudSvg,
    aliases: ["weather", "sky", "storage", "online"],
  },
  {
    id: "Code",
    description: "code",
    component: Code,
    rawSvg: CodeSvg,
    aliases: ["programming", "developer", "script", "software", "development"],
  },
  {
    id: "CreditCard",
    description: "credit card",
    component: CreditCard,
    rawSvg: CreditCardSvg,
    aliases: ["payment", "money", "bank", "finance", "card", "banking"],
  },
  {
    id: "Database",
    description: "database",
    component: Database,
    rawSvg: DatabaseSvg,
    aliases: ["storage", "data", "server", "information", "db"],
  },
  {
    id: "Eye",
    description: "eye",
    component: Eye,
    rawSvg: EyeSvg,
    aliases: ["vision", "strategy", "overview", "watch", "monitor", "observe", "insight"],
  },
  {
    id: "Fingerprint",
    description: "fingerprint",
    component: Fingerprint,
    rawSvg: FingerprintSvg,
    aliases: ["security", "identity", "biometric", "auth", "authentication"],
  },
  {
    id: "Flag",
    description: "flag",
    component: Flag,
    rawSvg: FlagSvg,
    aliases: ["mark", "signal", "indicator", "country", "marker", "location"],
  },
  {
    id: "FlaskConical",
    description: "flask conical",
    component: FlaskConical,
    rawSvg: FlaskConicalSvg,
    aliases: ["science", "chemistry", "discovery", "experiment", "lab", "research", "laboratory"],
  },
  {
    id: "Gamepad2",
    description: "gamepad",
    component: Gamepad2,
    rawSvg: Gamepad2Svg,
    aliases: ["controller", "game", "play", "console"],
  },
  {
    id: "Gem",
    description: "gem",
    component: Gem,
    rawSvg: GemSvg,
    aliases: ["diamond", "jewel", "precious", "stone"],
  },
  {
    id: "Gift",
    description: "gift",
    component: Gift,
    rawSvg: GiftSvg,
    aliases: ["present", "package", "reward", "give"],
  },
  {
    id: "GraduationCap",
    description: "graduation cap",
    component: GraduationCap,
    rawSvg: GraduationCapSvg,
    aliases: ["education", "school", "degree", "graduate"],
  },
  {
    id: "Info",
    description: "info",
    component: Info,
    rawSvg: InfoSvg,
    aliases: ["information", "help", "details", "about"],
  },
  {
    id: "KeyRound",
    description: "key round",
    component: KeyRound,
    rawSvg: KeyRoundSvg,
    aliases: ["lock", "security", "password", "access"],
  },
  {
    id: "Landmark",
    description: "landmark",
    component: Landmark,
    rawSvg: LandmarkSvg,
    aliases: ["building", "monument", "place", "location"],
  },
  {
    id: "Layers2",
    description: "layers",
    component: Layers2,
    rawSvg: Layers2Svg,
    aliases: ["stack", "level", "tier", "overlay", "project"],
  },
  {
    id: "LayoutList",
    description: "layout list",
    component: LayoutList,
    rawSvg: LayoutListSvg,
    aliases: ["list", "items", "menu", "options", "list view"],
  },
  {
    id: "LifeBuoy",
    description: "life buoy",
    component: LifeBuoy,
    rawSvg: LifeBuoySvg,
    aliases: ["help", "support", "rescue", "safety"],
  },
  {
    id: "Lightbulb",
    description: "lightbulb",
    component: Lightbulb,
    rawSvg: LightbulbSvg,
    aliases: ["idea", "light", "bulb", "inspiration"],
  },
  {
    id: "Link",
    description: "link",
    component: Link,
    rawSvg: LinkSvg,
    aliases: ["url", "connect", "chain", "reference", "connection"],
  },
  {
    id: "MapPinned",
    description: "map pinned",
    component: MapPinned,
    rawSvg: MapPinnedSvg,
    aliases: ["location", "place", "marker", "pin", "map", "journey"],
  },
  {
    id: "Microscope",
    description: "microscope",
    component: Microscope,
    rawSvg: MicroscopeSvg,
    aliases: ["discovery", "science", "lab", "research", "magnify"],
  },
  {
    id: "Monitor",
    description: "monitor",
    component: Monitor,
    rawSvg: MonitorSvg,
    aliases: ["screen", "display", "computer", "desktop"],
  },
  {
    id: "OctagonAlert",
    description: "octagon alert",
    component: OctagonAlert,
    rawSvg: OctagonAlertSvg,
    aliases: ["warning", "alert", "caution", "issue", "problem"],
  },
  {
    id: "MoonStar",
    description: "moon star",
    component: MoonStar,
    rawSvg: MoonStarSvg,
    aliases: ["night", "dark", "sleep", "evening"],
  },
  {
    id: "Paperclip",
    description: "paperclip",
    component: Paperclip,
    rawSvg: PaperclipSvg,
    aliases: ["attachment", "file", "clip", "attach"],
  },
  {
    id: "Pencil",
    description: "pencil",
    component: Pencil,
    rawSvg: PencilSvg,
    aliases: ["write", "edit", "draw", "mark"],
  },
  {
    id: "Plane",
    description: "plane",
    component: Plane,
    rawSvg: PlaneSvg,
    aliases: ["airplane", "aircraft", "travel", "flight", "transportation"],
  },
  {
    id: "Power",
    description: "power",
    component: Power,
    rawSvg: PowerSvg,
    aliases: ["on", "off", "switch", "energy"],
  },
  {
    id: "Presentation",
    description: "presentation",
    component: Presentation,
    rawSvg: PresentationSvg,
    aliases: ["slides", "deck", "pitch", "meeting", "demo", "project"],
  },
  {
    id: "Puzzle",
    description: "puzzle",
    component: Puzzle,
    rawSvg: PuzzleSvg,
    aliases: ["game", "piece", "solve", "challenge", "project"],
  },
  {
    id: "School",
    description: "school",
    component: School,
    rawSvg: SchoolSvg,
    aliases: ["education", "learn", "study", "university"],
  },
  {
    id: "Send",
    description: "send",
    component: Send,
    rawSvg: SendSvg,
    aliases: ["message", "mail", "email", "submit", "communication"],
  },
  {
    id: "Settings",
    description: "settings",
    component: Settings,
    rawSvg: SettingsSvg,
    aliases: ["configuration", "config", "cog", "gear", "preferences", "options", "setup"],
  },
  {
    id: "Ship",
    description: "ship",
    component: Ship,
    rawSvg: ShipSvg,
    aliases: ["delivery", "shipping", "transport", "logistics", "cargo"],
  },
  {
    id: "Shield",
    description: "shield",
    component: Shield,
    rawSvg: ShieldSvg,
    aliases: ["security", "protection", "defense", "guard"],
  },
  {
    id: "ShoppingCart",
    description: "shopping cart",
    component: ShoppingCart,
    rawSvg: ShoppingCartSvg,
    aliases: ["cart", "shop", "store", "buy"],
  },
  {
    id: "Smartphone",
    description: "smartphone",
    component: Smartphone,
    rawSvg: SmartphoneSvg,
    aliases: ["phone", "mobile", "device", "cell"],
  },
  {
    id: "Sparkles",
    description: "sparkles",
    component: Sparkles,
    rawSvg: SparklesSvg,
    aliases: ["magic", "shine", "glitter", "stars", "celebration", "special", "ai", "artificial intelligence"],
  },
  {
    id: "Speech",
    description: "speech",
    component: Speech,
    rawSvg: SpeechSvg,
    aliases: ["talk", "voice", "speak", "chat"],
  },
  {
    id: "Sprout",
    description: "sprout",
    component: Sprout,
    rawSvg: SproutSvg,
    aliases: ["plant", "grow", "seed", "nature", "growth", "sustainability"],
  },
  {
    id: "SquareCheck",
    description: "square check",
    component: SquareCheck,
    rawSvg: SquareCheckSvg,
    aliases: ["task", "completed", "done", "checklist", "finished"],
  },
  {
    id: "SquarePlus",
    description: "square plus",
    component: SquarePlus,
    rawSvg: SquarePlusSvg,
    aliases: ["add", "new", "create", "feature", "addition"],
  },
  {
    id: "Sun",
    description: "sun",
    component: Sun,
    rawSvg: SunSvg,
    aliases: ["light", "day", "weather", "bright"],
  },
  {
    id: "ThumbsUp",
    description: "thumbs up",
    component: ThumbsUp,
    rawSvg: ThumbsUpSvg,
    aliases: ["like", "approve", "agree", "positive", "approval"],
  },
  {
    id: "Volume2",
    description: "volume",
    component: Volume2,
    rawSvg: Volume2Svg,
    aliases: ["sound", "audio", "speaker", "music"],
  },
  {
    id: "Wallet",
    description: "wallet",
    component: Wallet,
    rawSvg: WalletSvg,
    aliases: ["money", "payment", "finance", "cash"],
  },
  {
    id: "WandSparkles",
    description: "wand sparkles",
    component: WandSparkles,
    rawSvg: WandSparklesSvg,
    aliases: ["magic", "sparkle", "glitter", "shine", "AI", "artificial intelligence"],
  },
  {
    id: "Wrench",
    description: "wrench",
    component: Wrench,
    rawSvg: WrenchSvg,
    aliases: ["tool", "fix", "repair", "maintenance"],
  },
];

export const themes = [
  { id: "default", swatchColor: "#cbd5e1", iconColor: "#64748b", bgColor: "#f1f5f9" },
  { id: "gray", swatchColor: "#6b7280", iconColor: "#1f2937", bgColor: "#e5e7eb" },
  { id: "red", swatchColor: "#ef4444", iconColor: "#dc2626", bgColor: "#fee2e2" },
  { id: "orange", swatchColor: "#f97316", iconColor: "#ea580c", bgColor: "#ffedd5" },
  { id: "yellow", swatchColor: "#eab308", iconColor: "#ca8a04", bgColor: "#fef9c3" },
  { id: "green", swatchColor: "#22c55e", iconColor: "#16a34a", bgColor: "#dcfce7" },
  { id: "blue", swatchColor: "#3b82f6", iconColor: "#2563eb", bgColor: "#dbeafe" },
  { id: "purple", swatchColor: "#a855f7", iconColor: "#9333ea", bgColor: "#f3e8ff" },
];
